export default __webpack_public_path__ + "static/media/hover_magiceden.e5b8a894.png";